import { render, staticRenderFns } from "./webSiteIndexData.vue?vue&type=template&id=661bedcb&scoped=true"
import script from "./webSiteIndexData.vue?vue&type=script&lang=js"
export * from "./webSiteIndexData.vue?vue&type=script&lang=js"
import style0 from "./webSiteIndexData.vue?vue&type=style&index=0&id=661bedcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661bedcb",
  null
  
)

export default component.exports